import { BoxProps } from '@joinrepublic/dls-ui-kit';

export type Size = '2xl' | 'xl' | 'lg' | 'md' | 'sm' | 'xs';

interface ISizeStyle {
  assetIcon: BoxProps;
  chainIcon: BoxProps;
  avatarSize: string;
}

export const SIZE_STYLES: Record<Size, ISizeStyle> = {
  '2xl': {
    assetIcon: {
      height: '64px',
      width: '64px',
      minH: '64px',
      minWidth: '64px',
    },
    chainIcon: {
      height: '32px',
      width: '32px',
      minH: '32px',
      minWidth: '32px',
    },
    avatarSize: '16',
  },
  xl: {
    assetIcon: {
      height: '40px',
      width: '40px',
      minH: '40px',
      minWidth: '40px',
    },
    chainIcon: {
      height: '20px',
      width: '20px',
      minH: '20px',
      minWidth: '20px',
    },
    avatarSize: '10',
  },
  lg: {
    assetIcon: {
      height: '32px',
      width: '32px',
      minH: '32px',
      minWidth: '32px',
    },
    chainIcon: {
      height: '16px',
      width: '16px',
      minH: '16px',
      minWidth: '16px',
    },
    avatarSize: '8',
  },
  md: {
    assetIcon: {
      height: '24px',
      width: '24px',
      minH: '24px',
      minWidth: '24px',
    },
    chainIcon: {
      height: '12px',
      width: '12px',
      minH: '12px',
      minWidth: '12px',
    },
    avatarSize: '6',
  },
  sm: {
    assetIcon: {
      height: '20px',
      width: '20px',
      minH: '20px',
      minWidth: '20px',
    },
    chainIcon: {
      height: '10px',
      width: '10px',
      minH: '10px',
      minWidth: '10px',
    },
    avatarSize: '5',
  },
  xs: {
    assetIcon: {
      height: '16px',
      width: '16px',
      minH: '16px',
      minWidth: '16px',
    },
    chainIcon: { height: '8px', width: '8px', minH: '8px', minWidth: '8px' },
    avatarSize: '4',
  },
};
